import RegisterPhoneError from './RegisterPhoneError';
class CountryCallingCodeIsNotSupported extends RegisterPhoneError {
    constructor(lada, options) {
        super(`100 ladrillos can not call to phone with lada: ${lada}`, options);
    }
}
export default CountryCallingCodeIsNotSupported;
